import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config/api";


export const Events = () => {

    const [events, setEvents] = useState([]);

    const [categoryFilter, setCategoryFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");

    useEffect(() => {

        axios
            .get(`${API_URL}/api/events`)
            .then((response) => {

                setEvents(response.data);

            })
            .catch((error) => {

                console.log(error);

            });

    }, []);

    const filteredEvents = events.filter((event) => {

        const categoryMatch =
            !categoryFilter ||
            event.category === categoryFilter;

        const dateMatch =
            !dateFilter ||
            event.event_date === dateFilter;

        return categoryMatch && dateMatch;

    });

    return (
        <>
            {/* Page Header */}

            <div className="container-fluid page-header py-5">
                <div className="container text-center py-5">

                    <h1 className="display-2 text-white mb-4">
                        Events
                    </h1>


                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center mb-0 animated slideInDown">

                            <li className="breadcrumb-item">
                                <a href="#">Home</a>
                            </li>

                            <li className="breadcrumb-item">
                                <a href="#">Pages</a>
                            </li>

                            <li
                                className="breadcrumb-item text-white"
                                aria-current="page"
                            >
                                Events
                            </li>

                        </ol>
                    </nav>

                </div>
            </div>

            {/* Filters */}

            <div className="container mt-5">

                <div className="row mb-4">

                    <div className="col-md-4 mb-2">

                        <select
                            className="form-control"
                            value={categoryFilter}
                            onChange={(e) =>
                                setCategoryFilter(e.target.value)
                            }
                        >

                            <option value="">
                                All Categories
                            </option>

                            <option value="medical-camp">
                                Medical Camps
                            </option>

                            <option value="education-sitting">
                                Education Sittings
                            </option>

                            <option value="health-awareness">
                                Health Awareness
                            </option>

                        </select>

                    </div>

                    <div className="col-md-4 mb-2">

                        <input
                            type="date"
                            className="form-control"
                            value={dateFilter}
                            onChange={(e) =>
                                setDateFilter(e.target.value)
                            }
                        />

                    </div>

                    <div className="col-md-4 mb-2">

                        <button
                            className="btn btn-secondary w-100"
                            onClick={() => {

                                setCategoryFilter("");
                                setDateFilter("");

                            }}
                        >
                            Clear Filters
                        </button>

                    </div>

                </div>

            </div>

            {/* Events */}

            <div className="container pb-5">

                <div className="row">

                    {filteredEvents.length > 0 ? (

                        filteredEvents.map((event) => (

                            <div
                                className="col-lg-6 col-md-6 mb-4"
                                key={event.id}
                            >

                                <div className="card h-100 shadow-sm">

                                    <img
                                        src={event.featured_image}
                                        alt={event.title}
                                        className="card-img-top"
                                        style={{
                                            height: "300px",
                                            objectFit: "cover"
                                        }}
                                    />

                                    <div className="card-body">

                                        <span className="badge bg-primary mb-2">

                                            {
                                                event.category === "medical-camp"
                                                    ? "Medical Camp"
                                                    : event.category === "education-sitting"
                                                    ? "Education Sitting"
                                                    : "Health Awareness"
                                            }

                                        </span>

                                        <h4>
                                            {event.title}
                                        </h4>

                                        <p className="text-muted">
                                            {event.event_date}
                                        </p>

                                        <Link
                                            to={`/events/${event.slug}`}
                                            className="btn btn-primary"
                                        >
                                            Read More
                                        </Link>

                                    </div>

                                </div>

                            </div>

                        ))

                    ) : (

                        <div className="col-12 text-center">

                            <h5>
                                No events found.
                            </h5>

                        </div>

                    )}

                </div>

            </div>
        </>
    );
};